module.exports = __webpack_public_path__ + "static/media/magz3.21abfb52.jpg";